<template>
    <section id="apropos" class="pt-20 relative lg:pt-[120px] pb-8 lg:pb-[70px]">
        <div class="container">
            <div class="flex flex-wrap -mx-4 mb-16">
                <div class="w-full md:w-1/2 lg:w-1/2 px-4">
                    <div class="mb-12 lg:mb-20 max-w-[620px]">
                        <span class="font-semibold text-lg text-primary mb-2 block"> À propos </span>
                        <h2 class="font-bold text-3xl sm:text-4xl md:text-[42px] text-dark mb-4">
                            Service adéquat
                        </h2>
                        <p class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-body-color">
                            Notre équipe analyse votre haie afin de vous offrir le service qu'elle nécessite,
                            que ce soit une simple taille, une installation ou une plantation de vos haies de
                            cèdres.
                        </p>
                    </div>
                </div>
                <div class="w-full md:w-1/2 lg:w-1/2 px-4">
                    <Photoswipe class="flex flex-column items-center justify-center">
                        <div class="flex flex-wrap justify-center text-center" :class="{'collapsed': isGalleryViewCollapsed}">
                            <img
                                v-for="(src, index) in imageList"
                                :key="`img-${index}`"
                                :src="src"
                                v-pswp="src"
                                :alt="`projet-realise-${index}`"
                                :style="getImageItemStyle(src)"
                            />
                        </div>
                    </Photoswipe>
                    <div class="flex justify-center mt-4">
                        <button class="
                            cursor-pointer
                            py-4 px-6 sm:px-10 inline-flex items-center
                            justify-center text-center text-dark text-base
                            bg-white hover:text-primary hover:shadow-lg
                            font-medium rounded-lg transition duration-300
                            ease-in-out"
                            @click="toggleCollapse()">
                            Voir {{ (isGalleryViewCollapsed) ? 'plus' : 'moins' }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap -mx-4">
                <div class="w-full md:w-1/2 lg:w-1/4 px-4">
                    <div class="mb-12 group wow fadeInUp" data-wow-delay=".1s">
                        <div
                            class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
                        >
                            <span
                                class="w-[70px] h-[70px] flex items-center justify-center bg-primary bg-opacity-20 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                            ></span>
                            <img width="35" height="35" :src="periodSvg" alt="periode de coupe" />
                        </div>
                        <h4 class="font-bold text-xl text-dark mb-3">Période de coupe</h4>
                        <p class="text-body-color mb-8 lg:mb-11 text-justify">
                            La saison débute dès le mois d'avril et se termine vers la fin du mois de
                            septembre afin de laisser le temps à vos haies de s'adapter aux froids hivernaux.
                        </p>
                    </div>
                </div>
                <div class="w-full md:w-1/2 lg:w-1/4 px-4">
                    <div class="mb-12 group wow fadeInUp" data-wow-delay=".15s">
                        <div
                            class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
                        >
                            <span
                                class="w-[70px] h-[70px] flex items-center justify-center bg-primary bg-opacity-20 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                            ></span>
                            <img width="35" height="35" :src="quantitySvg" alt="quantite-adequate"/>
                        </div>
                        <h4 class="font-bold text-xl text-dark mb-3">Quantité adéquate d'engrais</h4>
                        <p class="text-body-color mb-8 lg:mb-11 text-justify">
                            Quantité adéquate d'engrais selon le problème de votre haie. Nous offrons le
                            service de compost printaniers (riches en Azote et favorable à un feuillage bien
                            vert). Ainsi que des Angrais granulaires ajusté selon le mois d'application.
                        </p>
                    </div>
                </div>
                <div class="w-full md:w-1/2 lg:w-1/4 px-4">
                    <div class="mb-12 group wow fadeInUp" data-wow-delay=".2s">
                        <div
                            class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
                        >
                            <span
                                class="w-[70px] h-[70px] flex items-center justify-center bg-primary bg-opacity-20 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                            ></span>
                            <img width="35" height="35" :src="qualitySvg" alt="haute-qualitee" />
                        </div>
                        <h4 class="font-bold text-xl text-dark mb-3">Coupe de haute qualitée</h4>
                        <p class="text-body-color mb-8 lg:mb-11 text-justify">
                            Notre précision de coupe est la meilleure sur le marché, satisfation garantie.
                        </p>
                    </div>
                </div>
                <div class="w-full md:w-1/2 lg:w-1/4 px-4">
                    <div class="mb-12 group wow fadeInUp" data-wow-delay=".25s">
                        <div
                            class="w-[70px] h-[70px] flex items-center justify-center bg-primary rounded-2xl mb-8 relative z-10"
                        >
                            <span
                                class="w-[70px] h-[70px] flex items-center justify-center bg-primary bg-opacity-20 rounded-2xl mb-8 absolute z-[-1] top-0 left-0 rotate-[25deg] group-hover:rotate-45 duration-300"
                            ></span>
                            <img width="35" height="35" :src="judgeSvg" alt="travail-silencieux"/>
                        </div>
                        <h4 class="font-bold text-xl text-dark mb-3">Travail silencieux et écologique</h4>
                        <p class="text-body-color text-justify mb-8 lg:mb-11">
                            Nous avons décidé de strictement faire utilisation d'équipement électrique,
                            réduisant grandement le dérangement sonore que les services peuvent normalement
                            causer.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="shader absolute top-0 z-[-1]">
            <svg width="1440" height="830" viewBox="0 0 1440 830" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                d="M193.307 -273.321L1480.87 1014.24L1121.85 1373.26C1121.85 1373.26 731.745 983.231 478.513 729.927C225.976 477.317 -165.714 85.6993 -165.714 85.6993L193.307 -273.321Z"
                fill="url(#paint0_linear)"
            />
            <defs>
                <linearGradient
                id="paint0_linear"
                x1="1308.65"
                y1="1142.58"
                x2="602.827"
                y2="-418.681"
                gradientUnits="userSpaceOnUse"
                >
                <stop stop-color="#6be079" stop-opacity="0.76" />
                <stop offset="1" stop-color="#F5F2FD" stop-opacity="0" />
                <stop offset="1" stop-color="#F5F2FD" stop-opacity="0.096144" />
                </linearGradient>
            </defs>
            </svg>
  </div>
    </section>
</template>

<script>
export default {
    name: "AboutSection",
    methods: {
        getImageItemStyle(src) {
            return {
                "max-height": "10rem",
                backgroundImage: `url(${src})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                margin: "10px",
                "border-radius": "10px",
                "box-shadow": "0 0 4px 1px black"
            };
        },
        toggleCollapse() {
            this.isGalleryViewCollapsed = !this.isGalleryViewCollapsed;
        }
    },
    data() {
        return {
            isGalleryViewCollapsed: true,
            imageList: [
                require('@/assets/images/gallery/1.jpg'),
                require('@/assets/images/gallery/2.jpg'),
                require('@/assets/images/gallery/3.jpg'),
                require('@/assets/images/gallery/4.jpg'),
                require('@/assets/images/gallery/5.jpg'),
                require('@/assets/images/gallery/6.jpg'),
                require('@/assets/images/gallery/7.jpg'),
            ],
            periodSvg: require("@/assets/images/about/period.svg"),
            quantitySvg: require("@/assets/images/about/quantity.svg"),
            qualitySvg: require("@/assets/images/about/quality.svg"),
            judgeSvg: require("@/assets/images/about/judge.svg"),
        };
    },
};
</script>

<style lang="scss">
.shader {
    transform: scaleY(-1);
    right: 0;
}

img {
    z-index: 9;
}

.pswipe-gallery div {
    transition: all .4s ease-in-out;
    max-height: 120rem;
    overflow: hidden;

    &.collapsed {
        max-height: 11rem;
        transition: all .4s ease-in-out;
    }
}
</style>
